import { PRICE_VARIANT_PATTERN } from '@oefy/core';
import { z } from 'zod';

export const PRICE_VARIANT_RULE = 'A group name uses only lower case letters, digits and -';

export const priceVariantSchema = z
  .string()
  .trim()
  .toLowerCase()
  .pipe(z.string().regex(PRICE_VARIANT_PATTERN, PRICE_VARIANT_RULE));

export const priceTestSettingsSchema = z.object({
  enabled: z.boolean(),
  flagKey: z
    .string()
    .trim()
    .min(1)
    .max(100)
    .regex(/^[A-Za-z0-9_-]+$/, 'A flag key uses only letters, digits, - and _'),
  variants: z
    .array(priceVariantSchema)
    .max(10)
    .refine((variants) => new Set(variants).size === variants.length, {
      message: 'Each group can be listed once',
    }),
});

export const priceTestStatusSchema = priceTestSettingsSchema.extend({
  connected: z.boolean(),
});

export type PriceTestSettingsInput = z.input<typeof priceTestSettingsSchema>;
export type PriceTestSettingsValue = z.output<typeof priceTestSettingsSchema>;
export type PriceTestStatus = z.infer<typeof priceTestStatusSchema>;
